import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setBreadcrumb } from 'components/Navbar/modules';
import { resetAll } from 'modules/steps/actions';
import ThemeTable from '../components';


function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.themeTable || {},
    narratives: state.narratives.list,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    resetAll: bindActionCreators(resetAll, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ThemeTable));



// WEBPACK FOOTER //
// ./src/routes/ThemeTable/container/index.js